module.exports = __webpack_public_path__ + "static/media/skoob.eb7a320f.svg";